// extracted by mini-css-extract-plugin
var _1 = "BOz4SeqiaTPaVGZk57tC";
export { _1 as "appContainer" }
